/**
 * Resolves the active campaign slug from the build-time CAMPAIGN env variable.
 *
 * Kept in its own module (with no other imports) so that both the campaign
 * registry and the campaign API binding can depend on it without creating an
 * import cycle.
 *
 * No default is applied on purpose: a missing or unknown CAMPAIGN must fail
 * fast (see `index.ts` / `api.ts`) rather than silently shipping a fallback
 * campaign on the wrong domain.
 */
export const activeCampaignSlug: string | undefined = process.env.CAMPAIGN
